module.exports = __webpack_public_path__ + "static/media/start.3f33c40e.mp3";